<template>
  <div>
    <el-card class="box-card"
      v-for="(ticket) in tickets"
      :key="ticket.id"
      >
      <el-row :gutter="20">
        <el-col :xs="24" :md="12">
          <text-field
            v-model="ticket.id"
            :base="base"
            name="movie_ticket_id"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            :value="getTicketName(ticket)"
            :base="base"
            name="ticket_name"
            disabled
            >
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="ticket.txn_amount"
            :base="base"
            name="txn_amount"
            disabled
            >
            <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="refundTicketMap[ticket.id].amount"
            :base="base"
            name="refund_amount"
            disabled
            >
            <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="ticket.fee"
            :base="base"
            name="ticket_fee"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="ticket.fee_discount"
            :base="base"
            name="ticket_fee_discount"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="ticket.ez_service_fee"
            :base="base"
            name="ez_service_fee"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="ticket.fn_service_fee"
            :base="base"
            name="fn_service_fee"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.bonus"
            :base="base"
            name="bonus"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.promo_code_id"
            :base="base"
            name="promo_code_id"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.discount"
            :base="base"
            name="discount"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.ori_amount"
            :base="base"
            name="ori_amount"
            disabled
            >
            <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.ticket_contract_price"
            :base="base"
            name="ticket_contract_price"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.amount"
            :base="base"
            name="ticket_price"
            disabled
            >
          <template slot="prepend-input">{{ currencyCode }}</template>
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="ticket.qty"
            :base="base"
            name="qty"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            v-model.number="refundTicketMap[ticket.id].qty"
            :base="base"
            name="refund_qty"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="8">
          <text-field
            :value="ticket.qty - refundTicketMap[ticket.id].qty"
            :base="base"
            name="actual_qty"
            disabled
            >
          </text-field>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        {{ $t('api.movie_refund_ticket_log.title') }}
      </div>
      <el-table stripe border fit
        :data="refundTickets"
        style="width: 100%"
        >
        <el-table-column
          prop="orders_movie_ticket_id"
          :label="$t('api.orders.fields.movie_ticket_id.label')"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="qty"
          :label="$t('api.orders.fields.refund_qty.label')"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('api.orders.fields.refund_amount.label')"
          align="center"
          >
        </el-table-column>
        <time-field
          :isForm="false"
          name="created_at"
          >
        </time-field>
      </el-table>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'orders-movie-ticket',
  props: {
    base: {
      type: String,
      default: ''
    },
    tickets: {
      type: Array,
      default: () => []
    },
    refundTickets: {
      type: Array,
      default: () => []
    },
    currencyCode: {
      type: String
    }
  },
  computed: {
    refundTicketMap () {
      const rtMap = []
      for (let idx in this.tickets) {
        rtMap[this.tickets[idx].id] = {
          qty: 0,
          amount: 0
        }
      }
      for (let idx in this.refundTickets) {
        let rt = this.refundTickets[idx]
        rtMap[rt.orders_movie_ticket_id].qty += rt.qty
        rtMap[rt.orders_movie_ticket_id].amount += rt.amount
      }
      return rtMap
    }
  },
  methods: {
    getTicketName (ticket) {
      if (ticket.promo_code_id || ticket.bonus > 0) {
        return this.$t('api.optFields.movieTicketType.map.promo')
      }
      return ticket.movie_ticket_name
    }
  }
}

</script>
